/**
 * The open modals' Escape handlers, innermost last. One Escape reaches only the innermost modal: a
 * modal opened from inside another (the mandate editor's sales schedule) would otherwise close both.
 */
const escapeHandlers: (() => void)[] = [];

/**
 * Registers an open modal's Escape handler as the innermost; the returned function unregisters it
 * and is safe to call more than once.
 */
export function pushEscapeHandler(handler: () => void): () => void {
  if (escapeHandlers.length === 0)
    document.addEventListener("keydown", onKeydown);
  escapeHandlers.push(handler);
  return () => {
    const index = escapeHandlers.indexOf(handler);
    if (index === -1) return;
    escapeHandlers.splice(index, 1);
    if (escapeHandlers.length === 0)
      document.removeEventListener("keydown", onKeydown);
  };
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === "Escape") escapeHandlers.at(-1)?.();
}
